export default __webpack_public_path__ + "static/media/Ki5QrZeaFB.e4685552.gif";